import { configureStore} from '@reduxjs/toolkit';
import userReducer from './userSlice';

export default configureStore({
	reducer: {
		user: userReducer,
		// 여기에 slice 리듀서를 추가합니다.
	},
});